<div class="widget">
  <div class="amSuite-widget-header">
    {{ 'widgets.last-parties.title' | translate }}
  </div>
  <div class="amSuite-widget-block height-auto">

    @if (isLoading) {
    <div class="crm-list-widget__list" aria-busy="true" aria-live="polite">
      @for (slot of [1,2,3,4,5,6]; track slot) {
      <div class="crm-list-widget__skeleton" aria-hidden="true">
        <div class="crm-list-widget__skeleton-icon"></div>
        <div class="crm-list-widget__skeleton-main">
          <div class="crm-list-widget__skeleton-line crm-list-widget__skeleton-line--name"></div>
          <div class="crm-list-widget__skeleton-line crm-list-widget__skeleton-line--badge"></div>
        </div>
        <div class="crm-list-widget__skeleton-chevron"></div>
      </div>
      }
    </div>
    }
    @else if (hasDatas()) {
    <div class="crm-list-widget__list" role="list">
      @for (p of visitedParties; track $index) {
      <button type="button" class="party-card" role="listitem" [attr.aria-label]="p.fullName"
        (click)="onSelectParty(p)">
        <span class="party-card__icon" aria-hidden="true"><i class="pi pi-user"></i></span>
        <span class="party-card__main">
          <span class="party-card__name">{{ p.fullName }}</span>
          @if (p.smartCode || p.taxPayerCode) {
          <span class="party-card__codes">
            @if (p.smartCode) {
            <span class="party-card__pill party-card__pill--primary">{{ p.smartCode }}</span>
            }
            @if (p.taxPayerCode) {
            <span class="party-card__pill party-card__pill--secondary">{{ p.taxPayerCode }}</span>
            }
          </span>
          }
        </span>
        <i class="pi pi-chevron-right party-card__chevron" aria-hidden="true"></i>
      </button>
      }
    </div>
    }
    @else {
    <div class="crm-list-widget__empty">
      <i class="pi pi-inbox crm-list-widget__empty-icon" aria-hidden="true"></i>
      <p class="crm-list-widget__empty-text">
        {{ 'widgets.last-parties.noData' | translate }}
      </p>
    </div>
    }
  </div>
</div>
